import { Message } from 'element-ui'


//请求处理
export function requestFormat(data, options, showError = true ) {
  return new Promise((resove, reject) => {
    if (!showError) resove(data)
    if (data.error_code !== 0) {
      if (options.error.length) {
        options.error.map((arr) => {
          if (data.error_code == arr.code) {
            Message.error(arr.msg)
          }
        })
      } else {
        Message.error(data.error_message)
      }
      reject(data)
    } else {
      if (options.sucText) {
        Message.error(options.sucText)
      }
      resove(data)
    }
  })
}


/**
 * 分支处理
 * @param {Array} options
 * options:[{
 *  condition:true,
 *  fn:()=>{}
 * }]
 */
export function switchRun(options) {
  options.map((op) => {
    if (op.condition) { op.fn() }
  })
}

//输入提示
export function inputError(ob, map) {
  let rej = 0
  return Promise((resove, reject) => {
    Object.keys(ob).map((arr) => {
      if (ob[arr]=='' && rej == 0) {
        Message.error(`请输入${map[arr]}`)
        rej++
        reject()
      }
    })
    resove()
  })
}
